export const DEMAND = {
  N: 'N',
  D: 'D',
  L: 'L',
  I: 'I',
  T: 'T'
}
